import React, {forwardRef, useCallback} from 'react'

import PopupMenuButton from "../../../../../../core/gd-components/popover-menu/popup-menu-button/popup-menu-button"
import ProjectView_MoreMenu from "./more-popover/more-menu"
import ProjectView from "../../../../../../core/model2/project-view/project-view"

type Props = {
    className?          : string
    style?              : any

    projectView         : ProjectView

    dndPreview?         : boolean
    dndIsDragged?       : boolean

    isReadOnly?         : boolean
}

// const debug = "SubmenuItem"
const debug = false

const SubmenuItem = forwardRef((props: Props, ref: any) => {

    const showMore = props.projectView.hasMoreMenu && !props.isReadOnly

    const onTogglePopover = (value: boolean) => {
        if (value) {
            gd.utils.Dom.addClass(ref.current, 'with-more-popover')
        } else {
            gd.utils.Dom.removeClass(ref.current, 'with-more-popover')
        }
    }

    const onMenuItemClick = (e: React.MouseEvent) => {
        e.stopPropagation()
        props.projectView.open()
    }

    const showContextMenu = useCallback((e: React.MouseEvent) => {
        if (!showMore) return

        const menuParams = {
            view: props.projectView
        }

        gd.layout.contextMenu.show(e,
            <ProjectView_MoreMenu className     = "popover-project-view"
                                  menuParams    = {menuParams}
                                  hidePopover   = {() => gd.layout.contextMenu.hide()}/>,
            {
                component   : ref.current,
            }
        )
    }, [])

    const classes = Classes('item', props.className, {
        'dnd-preview'       : props.dndPreview,
        'dnd-is-dragged'    : props.dndIsDragged,
        'selected'          : props.projectView.id === gd.projectViews.currentView?.id,
        'with-more'         : props.projectView.hasMoreMenu
    })

    debug && console.log(debug,"render()", props)

    // style is required for ReorderList (pointer-events: none)
    return (
        <div ref            = {ref}
             className      = {classes}
             style          = {props.style}
             onClick        = {onMenuItemClick}
             onContextMenu  = {showContextMenu}>
            <div className="label max-w-200" title={props.projectView.name}>
                {props.projectView.name}
            </div>

            {showMore &&
                <PopupMenuButton className          = "ui5-ico-more s18"
                                 popoverClass       = "popover-project-view"
                                 menuComponent      = {ProjectView_MoreMenu}
                                 onTogglePopover    = {onTogglePopover}
                                 menuParams         = {{
                                     view: props.projectView
                                 }}/>}

            {props.projectView.isPrivate && <div className="icon-private ui5-ico-lock s8"/>}
        </div>
    )
})

export default SubmenuItem
